import { ApiService } from "./api.service";

export default class CityService extends ApiService {
  constructor() {
    super();
  }

  getOutlets(): Promise<any> {
    return super.getData("outlets");
  }

  getFeaturedBrands(): Promise<any> {
    return super.getData("brands/featured");
  }

  getBrands(): Promise<any> {
    return super.getData("brands");
  }

  getLatestNews(): Promise<any> {
    return super.getData("latestnews");
  }

  getNews(): Promise<any> {
    return super.getData("news");
  }

  getArticle(id): Promise<any> {
    return super.getData("news/" + id);
  }

  getBrand(id): Promise<any> {
    return super.getData("brand/" + id);
  }

  sendInquiry(form): Promise<any> {
    return super.postData("sendinquiry", form);
  }

  sendFeedback(form): Promise<any> {
    return super.postData("sendfeedback", form);
  }
}
